import SkillRating from "../components/SkillRating";

import Divider from "../components/Divider";
import { GitHubIcon, GmailIcon, LinkedInIcon } from "../components/Icon";
import { Tooltip } from "react-tooltip";
import { useEffect, useRef, useState } from "react";
import classNames from "classnames";

export default function About() {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  // const fileName = "Hasnain_CyberSecurity_Resume.pdf";

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  //   const fileURL = `${process.env.PUBLIC_URL}/${fileName}`;
  //   const link = document.createElement("a");

  //   link.href = fileURL;
  //   link.setAttribute("download", fileName);
  //   document.body.appendChild(link);
  //   link.click();

  //   if (link.parentNode) {
  //     link.parentNode.removeChild(link);
  //   }
  // };

  return (
    <div
      ref={ref}
      id="about-page"
      className={classNames(
        "w-full max-w-xl mx-auto relative my-6 transition-transform duration-700 ease-out",
        {
          "translate-y-0 opacity-100 pt-14": isVisible,
          "translate-y-10 opacity-0 ": !isVisible,
        }
      )}
    >
      <div className="px-6 flex flex-col items-center justify-center gap-4 pt-6">
        <div className="flex items-center justify-center gap-6 max-w-xl m-auto h-full">
          <a
            data-tooltip-id="tooltip-linkedin"
            data-tooltip-content="LinkedIn"
            href="https://www.linkedin.com/in/hasnain-i-36b80b261/"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedInIcon
              className={classNames("fill-white", {
                "slide-in-left": isVisible,
              })}
            />
          </a>
          <a
            data-tooltip-id="tooltip-github"
            data-tooltip-content="GitHub"
            href="https://github.com/Hasnaindev59"
            target="_blank"
            rel="noreferrer"
          >
            <GitHubIcon
              className={classNames("fill-white", {
                "slide-in-top": isVisible,
              })}
            />
          </a>
          <a
            data-tooltip-id="tooltip-email"
            data-tooltip-content="Email"
            href="mailto:hasnaincsdv@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
            <GmailIcon
              className={classNames("fill-white", {
                "slide-in-right": isVisible,
              })}
            />
          </a>
        </div>
        <Tooltip id="tooltip-linkedin" />
        <Tooltip id="tooltip-github" />
        <Tooltip id="tooltip-email" />
        <p className="text-sm">
        I am a second-year BSc Cybersecurity student at Aston University with a strong passion for digital innovation, IT, and AI technologies. With hands-on experience at WHG and a part-time role at Papa John's, I have developed a solid foundation in cybersecurity principles, technical troubleshooting, and customer service.

       My enthusiasm for cybersecurity and its intersection with AI aligns with the mission of advancing technological solutions and implementing innovative approaches in IT and security. I am continuously refining my skills to contribute to cutting-edge advancements in digital protection and AI-driven IT strategies.
          <br></br>
          <br></br>
      You may be thinking why this website. I created this website to showcase my projects and skills. in an easy to navigate way.
          <br></br>
          <br></br>
          Aside from cybersecurity, l like to study philosophy,pyschology, learning new languages,
          reading books and playing table tennis.
        </p>
        
      </div>
      <Divider
        id={"about-skills"}
        label={"Skills"}
        labelSize={"text-lg"}
        className={"px-6"}
      />
      <div className="px-6 pb-3 flex flex-col">
        <p className="text-lg font-bold">Featured Skills</p>
      </div>
      <div className="px-6 grid grid-cols-2 gap-4">
        <SkillRating isVisible={isVisible} skill={"Java"} rating={9.5} />
        <SkillRating isVisible={isVisible} skill={"JavaScript"} rating={9.5} />
        <SkillRating isVisible={isVisible} skill={"SQL"} rating={9.5} />
        <SkillRating isVisible={isVisible} skill={"react"} rating={7} />
        <SkillRating isVisible={isVisible} skill={"PHP"} rating={7} />
        <SkillRating isVisible={isVisible} skill={"Python"} rating={4} />
        <SkillRating isVisible={isVisible} skill={"C++"} rating={4} />
        <SkillRating isVisible={isVisible} skill={"WireShark"} rating={7} />
        <SkillRating isVisible={isVisible} skill={"Nmap"} rating={7} />
        <SkillRating isVisible={isVisible} skill={"OSINT"} rating={9.5} />
       

      </div>
      <div className="px-6  pt-6 flex flex-col">
        <p className="text-lg font-bold">All Skills</p>
      </div>
      <div className="px-6 flex flex-col">
        <p className="font-semibold text-sm mt-2 mb-1 ">Programming</p>
        <p className="text-sm space-y-1">
          JavaScript,Node.js,HTML (HTML5), CSS, Python currently learning,
          SQL, Java, C programming, C++, PHP, Shell Scripting.
        </p>
      </div>
      <div className="px-6 flex flex-col">
        <p className="font-semibold text-sm mt-2 mb-1">Databases</p>
        <p className="text-sm space-y-1">
          MySQL
        </p>
      </div>
      <div className="px-6 flex flex-col">
        <p className="font-semibold text-sm mt-2 mb-1">Tools/Platforms</p>
        <p className="text-sm space-y-1">
          Git,GitHub, Docker, VS Code,Eclipse, IntelliJ, Figma,fleet,Kali linux,
          NMAP,OSINT,maltego,spider crawl,LLM (OpenAI) currently learning.
        </p>
      </div>
      <div className="px-6 flex flex-col">
        <p className="font-semibold text-sm mt-2 mb-1">Methodologies</p>
        <p className="text-sm space-y-1">
        Test-Driven Development (TDD)
        </p>
      </div>
      <div className="px-6 flex flex-col">
        <p className="font-semibold text-sm mt-2 mb-1">Soft Skills</p>
        <p className="text-sm space-y-1">
          Communication, Collaboration, Problem-solving, Adaptability, Time
          Management, Leadership, Creativity, Attention to Detail, Conflict Resolution, Critical Thinking.
        </p>
      </div>
      <Divider
        id={"about-experience"}
        label={"Experience"}
        labelSize={"text-lg"}
        className={"px-6"}
      />
      <div className="px-6 flex flex-col">
        {/* Papa Johns Experience */}
        <div className="flex flex-col">
          <p className="text-lg font-bold">Papa Johns</p>
          <p className="font-semibold text-sm">
            Delivery driver/Team member | Part-time | UK
          </p>
          <p className="font-semibold text-sm">Jan 2024 - Present</p>
          
          <p className="font-semibold text-sm mt-2 mb-1">
            Key Responsibilities
          </p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
              Ensured timely order delivery, reducing wait times and improving service efficiency under pressure.
            </li>
            <li>
              Handled transactions and customer queries, demonstrating problem-solving skills. 
            </li>
            <li>
              Worked collaboratively with team members to maintain a positive work environment and ensure smooth operations.
            </li>
            <li>
              Managed stock levels to ensure inventory was always full, contributing to uninterrupted service and customer satisfaction.
            </li>
            <li>
              Managed customer orders over the phone and in person, strengthening communication and interpersonal skills to ensure a positive service experience.
            </li>
          </ul>
        </div>
        
        <br />

         {/* Clifford Chance Cyber Security Global Job Simulation */}
        <div className="flex flex-col">
          <p className="text-lg font-bold">Clifford Chance Cyber Security Global Job Simulation</p>
          <p className="font-semibold text-sm">Remote | UK</p>
          <p className="font-semibold text-sm">May 2025</p>

          <p className="font-semibold text-sm mt-2 mb-1">Key Responsibilities</p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
            Completed the Clifford Chance job simulation where I assisted various clients with legal issues relating to cyber breaches.
            </li>
            <li>
            Provided guidance about responding to an ICO Dawn Raid to the managing partner of a rapidly growing online travel company.
            </li>
            <li>
            Assisted a major eCommerce business to notify stakeholders about a data breach in accordance with the GDPR.
            </li>
            <li>
            Formulated defensive strategies for a client with data centre operations to appropriately respond to a data breach.
            </li>
          </ul>
        </div>

        <br />
        
        {/* IEUK Technology Virtual Internship */}
        <div className="flex flex-col">
          <p className="text-lg font-bold">IEUK Technology Virtual Internship</p>
          <p className="font-semibold text-sm">Remote | UK</p>
          <p className="font-semibold text-sm">June 2024</p>

          <p className="font-semibold text-sm mt-2 mb-1">Key Responsibilities</p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
              Led a tech-driven project for Deloitte and PwC, collaborating with teams from Lloyds, BT, and British Airways to address real-world challenges, which enhanced my leadership skills.
            </li>
            <li>
              Improved project management and presentation skills through leadership workshops, networking with industry experts.
            </li>
            <li>
              Demonstrated adaptability by responding to complex problems with innovative solutions.
            </li>
          </ul>
        </div>

        <br />

        {/* WHG Internship */}
        <div className="flex flex-col">
          <p className="text-lg font-bold">WHG</p>
          <p className="font-semibold text-sm">I.T Technician | 1 week Internship | UK</p>
          <p className="font-semibold text-sm">June 2022 - July 2022</p>

          <p className="font-semibold text-sm mt-2 mb-1">Key Responsibilities</p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
              Set up IT systems for new employees, which improved onboarding and ensured smooth technical integration.
            </li>
            <li>
              Provided IT support by resolving hardware and software issues and configuring network setups to improve system performance, enhancing my problem-solving and troubleshooting skills.
            </li>
            <li>
              Managed user accounts and access control, ensuring compliance with GDPR and security protocols, which improved my understanding of data privacy regulations and attention to detail in managing secure data.
            </li>
          </ul>
        </div>
      </div>

      <Divider
        id={"voluntary-work"}
        label={"Voluntary work"}
        labelSize={"text-lg"}
        className={"px-6"}
      />
      
      <div className="px-6 flex flex-col">
        {/* Aston University Student Mentor */}
        <div className="flex flex-col">
          <p className="text-lg font-bold">Aston University</p>
          <p className="font-semibold text-sm">
            Student Mentor | UK
          </p>
          <p className="font-semibold text-sm">Sep 2024 - Present</p>
          
          <p className="font-semibold text-sm mt-2 mb-1">
            Key Responsibilities
          </p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
              Provided 1:1 mentorship to first-year Cybersecurity student, supporting their transition into university life.
            </li>
            <li>
              Shared study strategies, technical resources, and career guidance tailored to cybersecurity.
            </li>
            <li>
              Fostered a supportive, inclusive environment that promote academic and personal development.
            </li>
            <li>
              Acted as a point of contact between students and faculty to encourage engagement and communication.
            </li>
          </ul>
        </div>
        
        <br />
        
        {/* Aston University Auntie Volunteer */}
        <div className="flex flex-col">
          <p className="text-lg font-bold">Aston University</p>
          <p className="font-semibold text-sm">
            Aston auntie volunteer | UK
          </p>
          <p className="font-semibold text-sm">Sep 2024</p>
          
          <p className="font-semibold text-sm mt-2 mb-1">
            Key Responsibilities
          </p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
              Organized and led events such as a speed meet and gaming tournament, fostering student engagement and community building, which enhanced my event planning skills and ability to work collaboratively in a team-focused environment.  
            </li>
            <li>
              Assisted at the Freshers' Week helpdesk, supporting new students with orientation, which strengthened my communication and interpersonal skills, particularly in providing clear, empathetic guidance to newcomers.
            </li>
            <li>
              Strengthened active listening skills by addressing new students' concerns and providing supportive, considerate guidance.
            </li>
          </ul>
        </div>
        
        <br />
        
        {/* Bluecoat Academy Scribe */}
        <div className="flex flex-col">
          <p className="text-lg font-bold">Bluecoat Academy</p>
          <p className="font-semibold text-sm">
            Scribe/Amanuensis | UK
          </p>
          <p className="font-semibold text-sm">2023</p>
          
          <p className="font-semibold text-sm mt-2 mb-1">
            Key Responsibilities
          </p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
              Provided accurate transcription services during exams, helping students achieve fair assessment outcomes, which developed my attention to detail and ability to work under time constraints while maintaining accuracy.
            </li>
          </ul>
        </div>
        
        <br />
        
        {/* Bluecoat Academy Teaching Assistant */}
        <div className="flex flex-col">
          <p className="text-lg font-bold">Bluecoat Academy</p>
          <p className="font-semibold text-sm">
            Teaching Assistant | UK
          </p>
          <p className="font-semibold text-sm">2021 - 2023</p>
          
          <p className="font-semibold text-sm mt-2 mb-1">
            Key Responsibilities
          </p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
              Assisted students in IT and Religious Education, improving their academic performance through targeted support and revision techniques, which cultivated my mentoring skills and ability to effectively adapt teaching methods to meet diverse learning needs.
            </li>
          </ul>
        </div>
      </div>
      
      <Divider
        id={"about-education"}
        label={"Education"}
        labelSize={"text-lg"}
        className={"px-6"}
      />

      <div className="px-6 flex flex-col">
        <div className="flex flex-col">
          <p className="text-lg font-bold">
            Bachelor of Science Honours | Cybersecurity
          </p>
          <p className="font-semibold text-sm">
            Aston University
          </p>
          <p className="font-semibold text-sm">Graduated 2027</p>
          <p className="font-semibold text-sm mt-2 mb-1">Relevant Courses</p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
              Operating systems
            </li>
            <li>
              Security Thinking and Fundamentals
            </li>
            <li>
              Internet Applications & Database Design
            </li>
            <li>
              Data Encryption, Data Integrity, and Authentication
            </li>
            <li>
              Human Factors In Security
            </li>
          </ul>

          <p className="font-semibold text-sm mt-2 mb-1">Key Projects</p>
          <ul className="text-sm list-disc pl-4 space-y-1">
            <li>
              Learning deep into operating systems, including Linux and Windows, and their security features and doing kernel programming with C.
            </li>
            <li>
              Learning and experimenting with various encryption algorithms and encrypting/decrypting messages.
            </li>
            <li>
              Built 3 projects each of them focusing on a differerent progamming language. First one was a CV website, second one was a SQL database and the third one was a full website using both frontend and backend technologies. 
            </li>
            <li>
              Learnt and experimented with cryptography, including symmetric and asymmetric encryption, hashing algorithms, and digital signatures.
            </li>
            <li>
              Using OSINT tools such as Maltego, Spiderfoot, and Shodan to extract public information from the web and analyze it.
            </li> 
          </ul>
        </div>
      </div>
    </div>
  );
}

